module.exports = __webpack_public_path__ + "img/Autocolant TMH_55mm x 60mm-01.50f1f6c1.jpg";